import { motion } from 'motion/react'

type TileLayoutInfoDisplayProps = {
  rowStart: number
  colStart: number
  rowSpan: number
  colSpan: number
}

export function TileLayoutInfoDisplay({ rowStart, colStart, rowSpan, colSpan }: TileLayoutInfoDisplayProps) {
  return (
    <motion.div
      className="absolute right-2.5 top-2.5 flex h-fit w-fit flex-col items-center justify-center rounded-md border-foreground bg-background shadow"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.8, duration: 0.3 }}
    >
      <div className="rounded bg-secondary/25">
        <div className="p-2.5 text-base font-semibold">Tile size & position:</div>
        <div className="grid grid-cols-[1fr_min-content] gap-x-5 p-2.5 pt-0 leading-tight">
          <span>Row start:</span>
          <span>{rowStart}</span>
          <span>Column start:</span>
          <span>{colStart}</span>
          <span>Row span:</span>
          <span>{rowSpan}</span>
          <span>Column span:</span>
          <span>{colSpan}</span>
        </div>
      </div>
    </motion.div>
  )
}
